import { createContext } from 'react'

const SetNewPickIdContext = createContext()

export default SetNewPickIdContext
